import {
    GET_ALL_USERS_ACCESS_CODE,
    GET_USERS_ACCESS_CODE,
    UPDATE_USERS_ACCESS_CODE,
    REMOVE_USERS_ACCESS_CODE,
    USER_ACCESS_CODE_FILTER_CLEAN,
    USER_ACCESS_CODE_FILTER,
} from "Store/constants";

const initialState = {
    usersAccessCode : [],
    id              : "",
    page            : 1,
    search          : "",
    totalPages      : 1,
};

export default function usersAccessCodeReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_USERS_ACCESS_CODE:
            return {
                ...state,
                usersAccessCode : action.payload.data ?? [],
                page            : action.payload.page ?? [],
                totalPages      : action.payload.totalPages ?? [],
            };
        case GET_USERS_ACCESS_CODE:
            return {
                ...state,
                id : action.payload.id ?? "",
            };
        case USER_ACCESS_CODE_FILTER:
            return {
                ...state,
                ...action.payload,
            };
        case UPDATE_USERS_ACCESS_CODE:
            const codeId = action.payload._id;
            const codeData = action.payload.data;
            const copyState = [...state.usersAccessCode];
            const index = copyState.findIndex(item => item._id === codeId);

            if (index > -1) {
                copyState[index] = codeData;

                return {
                    ...state,
                    usersAccessCode : copyState,
                };
            }

            return {
                ...state,
                usersAccessCode : [...state.usersAccessCode, action.payload.data],
            };
        case REMOVE_USERS_ACCESS_CODE: {
            const newUsers = state.usersAccessCode?.filter(code => code._id !== action.payload._id);

            return {
                ...state,
                usersAccessCode : newUsers,
            };
        }
        case USER_ACCESS_CODE_FILTER_CLEAN : {
            return {
                ...state,
                id : "",
            };
        }
        default:
            return state;
    }
}

